// extracted by mini-css-extract-plugin
module.exports = {"registrationForm":"RegistrationForm_registrationForm__rT3Ky","successMessage":"RegistrationForm_successMessage__P4rtl"};